// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';
import VueProgressBar from 'vue-progressbar';
import VueI18n from 'vue-i18n';
import SocialSharing from 'vue-social-sharing';
import VueCookies from 'vue-cookies'

import PlayerCdn from 'playerCdn';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
library.add(fas, far, fab)
import {
  faCheck,
  faChevronCircleRight,
  faChevronCircleLeft,
  faEnvelopeSquare,
  faCopy,
  faShareSquare,
  faTimes,
  faArrowRight,
  faArrowLeft,
  faPhone,
  faShareAlt,
  faChevronLeft,
  faChevronRight,
  faCode,
} from '@fortawesome/free-solid-svg-icons';
import { faThumbsUp as fasThumbUp } from '@fortawesome/free-solid-svg-icons';
import { faCalendarAlt, faEye, faClock,  faThumbsUp ,faCalendar} from '@fortawesome/free-regular-svg-icons';
import {
  faFacebook,
  faYoutube,
  faFacebookSquare,
  faFacebookF,
  faTwitterSquare,
  faTwitter,
  faLinkedin,
  faLinkedinIn,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import 'bootstrap';

import router from './router';
import routerUser from './router/user';

import App from './App';
import Default from './layouts/Default.vue';
import store from './store';
import i18n from './i18n';
window.eventHub = new Vue();

Vue.use(VueScrollTo);

library.add(
  faCheck,
  faChevronCircleRight,
  faChevronCircleLeft,
  faFacebook,
  faYoutube,
  faEnvelopeSquare,
  faCopy,
  faShareSquare,
  faTimes,
  faArrowRight,
  faArrowLeft,
  faCalendarAlt,
  faEye,
  faClock,
  faPhone,
  faFacebookSquare,
  faTwitterSquare,
  faLinkedin,
  faShareAlt,
  faFacebookF,
  faLinkedinIn,
  faTwitter,
  faChevronLeft,
  faChevronRight,
  faCode,
  faThumbsUp,
  fasThumbUp,
  faCalendar
);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(PlayerCdn);
Vue.use(SocialSharing);
Vue.use(VueCookies)
Vue.component('default-layout', Default);

Vue.config.productionTip = false;

Vue.use(VueProgressBar, {
  color: '#C4B200',
  failedColor: 'red',
  height: '3px',
});

const channel = process.env.ID_CHANNEL;
/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router: (channel && channel !== false && channel !== 'false') ? router : routerUser,
  components: { App },
  store,
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js